<template>
  <div
    class="expanding-information"
    :class="{'open': modifiedShow}"
  >
    <div class="expanding-information-wrapper">
      <slot />
      <div
        class="expanding-information__toggle-button"
        @click="toggle()"
      >
        <div class="expanding-information__toggle-button-wrapper">
          <font-awesome-icon :icon="['fas', 'angle-down']" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  name: 'ExpandingInformation',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modifiedShow: false
    }
  },
  computed: {
  },
  watch: {
    show(newVal) {
      this.modifiedShow = newVal
    }
  },
  mounted() {
  },
  methods: {
    toggle() {
      this.modifiedShow = !this.modifiedShow
      this.$emit('change', this.modifiedShow)
    }
  }
}
</script>

<style lang="scss">
.expanding-information {
  @include optionsPanel(0px);
  &__row {
    display: block;
  }
}
</style>
